import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("communications connect");
   }

  markAsRead(event) {
    console.log("markAsRead", event.currentTarget.dataset.markAsReadUrl);
    event.preventDefault()
    fetch(event.currentTarget.dataset.markAsReadUrl, {
      method: 'PATCH',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      credentials: 'same-origin'
    })
  }
} 